export default "<mat-progress-bar mode=\"indeterminate\" color=\"accent\"></mat-progress-bar>"